export default {
  typography: {
    fontFamily: '"Apercu Pro", "Helvetica Neue", Arial, sans-serif',
    fontSize: '18px',
  },

  colors: {
    textColor: 'inherit',
    // textColor: '#424242',
    primaryTextColor: '#ffffff',
    primaryColor: '#292929',
    titleColor: '#424242',
    alertColor: '#d9534f',
  },
};
